module.exports = __webpack_public_path__ + "media/images/admin/icons/watch-129e41efd720742f7b09236d79496c60.svg";